/* eslint-disable */
// import libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// import custom components
import { DATASOURCES, getDataSource } from 'state/services/utils';
import CustomTableComponent from '../../components/Common/Table/CustomTableComponent';
import TableHeader from '../../components/Common/Table/TableHeader';
import FormattedDate from '../../components/Common/FormattedDate';
import { getEKGAlgorithmDeterminationDisplayText } from '../../../legacy/constants/recordingMaps';
import SplitLineRowText from '../../components/Common/Table/CellRendererComponents/SplitTextRow/SplitTextRow';

// constants
import { ACUITY_MAP } from '../../components/Common/Table/Constants/Constants';

// import css
import styles from './KardiaRxCCTWorkListResult.css';

import { routeChangeAction } from '../../state/kardiaRxCCTWorklist/KardiaRxCCTWorklistActions';

import { printTechIntrString } from '../../pages/Annotation/utils/TechIntrParser'
class KardiaRxCCTWorkListResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      workListTable: 1,
    };
  }

  componentDidMount = () => { };

  componentWillReceiveProps = () => { };

  componentDidUpdate(prevProps, prevState) {
    const { CCT_DROPDOWN_VALUE } = this.props;
    if (
      CCT_DROPDOWN_VALUE &&
      prevProps.CCT_DROPDOWN_VALUE !== CCT_DROPDOWN_VALUE
    ) {
      this.setState({
        workListTable: CCT_DROPDOWN_VALUE,
      });
    }
  }
  // Row clicked
  clickedRow = (rowData, index) => {
    // console.log("rowDate=>", rowData);
    // eslint-disable-next-line no-shadow
    const { routeChangeAction } = this.props;
    routeChangeAction(rowData.recording.id, rowData);
  };

  render() {
    const { CCT_WORK_LIST_STATE } = this.props;
    const { workListTable } = this.state;

    let COLUMS;
    switch (workListTable) {
      case 1:
      case 2:
      case 3:
        COLUMS = [
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="PATIENT"
                  keyMap="first_name"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'firstName',
            key: 'first_name',
            sorter: (a, b) =>
              a.patient.first_name &&
              a.patient.first_name.localeCompare(b.patient.first_name),
            render: (text, record, index) => {
              return (
                <SplitLineRowText
                  rowL1Data={`${record.patient.last_name} , ${record.patient.first_name}`}
                  rowL2Data={record.patient.mrn}
                />
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="ECG ARRIVAL DATE/TIME"
                  keyMap="created_at"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'createdAt',
            key: 'created_at',
            sorter: (a, b) => {
              const dateA = new Date(a.recording.created_at);
              const dateB = new Date(b.recording.created_at);
              return dateA - dateB;
            },
            render: (text, record, index) => {
              return <FormattedDate date={record.recording.recorded_at} />;
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="ACUITY"
                  keyMap="acuity"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'acuity',
            key: 'acuity',
            sorter: (a, b) =>
              a.recording.acuity &&
              a.recording.acuity.localeCompare(b.recording.acuity),
            render: (text, record, index) => {
              return record.recording.acuity ? (
                <div style={{ textAlign: 'center' }}>
                  {ACUITY_MAP[record.recording.acuity]}
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>-</div>
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="KARDIA DETERMINATION"
                  keyMap="algorithm_determination"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'algorithm_determination',
            key: 'algorithm_determination',
            width: 200,
            sorter: (a, b) =>
              a.recording.algorithm_determination &&
              a.recording.algorithm_determination.localeCompare(
                b.recording.algorithm_determination,
              ),
            render: (text, record, index) => {
              let data = '-';
              if (record.recording.algorithm_determination) {
                data = getEKGAlgorithmDeterminationDisplayText(
                  record.recording.algorithm_determination,
                  record.recording.algorithm_package,
                );
              }
              return data;
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="TECH INTERPRETATION"
                  keyMap="tch"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'email',
            key: 'tch',
            width: 200,
            sorter: (a, b) =>
              a.recording.email &&
              a.recording.email.localeCompare(b.recording.email),
            render: (text, record, index) => {
              let data = '';
              if (record.recording.tech_interpretation && record.recording.tech_interpretation.length) {
                data = printTechIntrString(record.recording.tech_interpretation)
              }
              return data ? (
                <div style={{ textAlign: 'center' }}>
                  {data && data.length >= 50 ? data.substring(0, 49) + '...' : data}
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>-</div>
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="PROVIDER"
                  keyMap="first_name"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'first_name',
            key: 'first_name',
            sorter: (a, b) =>
              a.provider.team_name &&
              a.provider.team_name.localeCompare(b.provider.team_name),
            render: (text, record, index) => {
              return (
                <SplitLineRowText
                  rowL1Data={`${record.provider.first_name} ${record.provider.last_name}`}
                  rowL2Data={record.provider.team_name}
                />
              );
            },
          },
        ];
        break;
      case 4:
        COLUMS = [
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="PATIENT"
                  keyMap="first_name"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'firstName',
            key: 'first_name',
            sorter: (a, b) =>
              a.patient.first_name &&
              a.patient.first_name.localeCompare(b.patient.first_name),
            render: (text, record, index) => {
              return (
                <SplitLineRowText
                  rowL1Data={`${record.patient.last_name} , ${record.patient.first_name}`}
                  rowL2Data={record.patient.mrn}
                />
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="ECG ARRIVAL DATE/TIME"
                  keyMap="created_at"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'createdAt',
            key: 'created_at',
            sorter: (a, b) => {
              const dateA = new Date(a.recording.created_at);
              const dateB = new Date(b.recording.created_at);
              return dateA - dateB;
            },
            render: (text, record, index) => {
              return <FormattedDate date={record.recording.recorded_at} />;
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="ACUITY"
                  keyMap="acuity"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'acuity',
            key: 'acuity',
            sorter: (a, b) =>
              a.recording.acuity &&
              a.recording.acuity.localeCompare(b.recording.acuity),
            render: (text, record, index) => {
              return record.recording.acuity ? (
                <div style={{ textAlign: 'center' }}>
                  {ACUITY_MAP[record.recording.acuity]}
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>-</div>
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="KARDIA DETERMINATION"
                  keyMap="algorithm_determination"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'algorithm_determination',
            key: 'algorithm_determination',
            width: 200,
            sorter: (a, b) =>
              a.recording.algorithm_determination &&
              a.recording.algorithm_determination.localeCompare(
                b.recording.algorithm_determination,
              ),
            render: (text, record, index) => {
              let data = '-';
              if (record.recording.algorithm_determination) {
                data = getEKGAlgorithmDeterminationDisplayText(
                  record.recording.algorithm_determination,
                  record.recording.algorithm_package,
                );
              }
              return data;
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="TECH INTERPRETATION"
                  keyMap="tch"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'email',
            key: 'tch',
            width: 200,
            sorter: (a, b) =>
              a.recording.email &&
              a.recording.email.localeCompare(b.recording.email),
            render: (text, record, index) => {
              let data = '';
              if (record.recording.tech_interpretation && record.recording.tech_interpretation.length) {
                data = printTechIntrString(record.recording.tech_interpretation)
              }
              return data ? (
                <div style={{ textAlign: 'center' }}>
                  {data && data.length >= 50 ? data.substring(0, 49) + '...' : data}
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>-</div>
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="PROVIDER VIEWED"
                  keyMap="provider_viewed"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'first_name',
            key: 'provider_viewed',
            sorter: (a, b) =>
              a.recording.provider_viewed - b.recording.provider_viewed,
            render: (text, record, index) =>
              `${record.recording.provider_viewed ? 'Yes' : 'No'}`,
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="PROVIDER"
                  keyMap="first_name"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'first_name',
            key: 'first_name',
            sorter: (a, b) =>
              a.provider.team_name &&
              a.provider.team_name.localeCompare(b.provider.team_name),
            render: (text, record, index) => {
              return (
                <SplitLineRowText
                  rowL1Data={`${record.provider.first_name} ${record.provider.last_name}`}
                  rowL2Data={record.provider.team_name}
                />
              );
            },
          },
        ];
        break;
      case 5:
        COLUMS = [
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="PATIENT"
                  keyMap="first_name"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'firstName',
            key: 'first_name',
            sorter: (a, b) =>
              a.patient.first_name &&
              a.patient.first_name.localeCompare(b.patient.first_name),
            render: (text, record, index) => {
              return (
                <SplitLineRowText
                  rowL1Data={`${record.patient.last_name} , ${record.patient.first_name}`}
                  rowL2Data={record.patient.mrn}
                />
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="ECG ARRIVAL DATE/TIME"
                  keyMap="created_at"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'createdAt',
            key: 'created_at',
            sorter: (a, b) => {
              const dateA = new Date(a.recording.created_at);
              const dateB = new Date(b.recording.created_at);
              return dateA - dateB;
            },
            render: (text, record, index) => {
              return <FormattedDate date={record.recording.recorded_at} />;
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="ACUITY"
                  keyMap="acuity"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'acuity',
            key: 'acuity',
            sorter: (a, b) =>
              a.recording.acuity &&
              a.recording.acuity.localeCompare(b.recording.acuity),
            render: (text, record, index) => {
              return record.recording.acuity ? (
                <div style={{ textAlign: 'center' }}>
                  {ACUITY_MAP[record.recording.acuity]}
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>-</div>
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="KARDIA DETERMINATION"
                  keyMap="algorithm_determination"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'algorithm_determination',
            key: 'algorithm_determination',
            width: 200,
            sorter: (a, b) =>
              a.recording.algorithm_determination &&
              a.recording.algorithm_determination.localeCompare(
                b.recording.algorithm_determination,
              ),
            render: (text, record, index) => {
              let data = '-';
              if (record.recording.algorithm_determination) {
                data = getEKGAlgorithmDeterminationDisplayText(
                  record.recording.algorithm_determination,
                  record.recording.algorithm_package,
                );
              }
              return data;
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="TECH INTERPRETATION"
                  keyMap="tch"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'email',
            key: 'tch',
            width: 200,
            sorter: (a, b) =>
              a.recording.email &&
              a.recording.email.localeCompare(b.recording.email),
            render: (text, record, index) => {
              let data = '';
              if (record.recording.tech_interpretation && record.recording.tech_interpretation.length) {
                data = printTechIntrString(record.recording.tech_interpretation)
              }
              return data ? (
                <div style={{ textAlign: 'center' }}>
                  {data && data.length >= 50 ? data.substring(0, 49) + '...' : data}
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>-</div>
              );
            },
          },
          {
            title: ({ sortOrder, sortColumn, filters }) => {
              return (
                <TableHeader
                  headerTxt="ARCHIVE REASON"
                  keyMap="archive_reason"
                  enableFilterRow={false}
                  enableFilter={false}
                  // filterFunction={() => this.filterChange()}
                  sortOrder={sortOrder}
                  sortColumn={sortColumn}
                />
              );
            },
            dataIndex: 'archive_reason',
            key: 'archive_reason',
            sorter: (a, b) =>
              a.provider.team_name &&
              a.provider.team_name.localeCompare(b.provider.team_name),
            render: (text, record, index) => {
              return record.recording.archive_reason ? (
                <div style={{ textAlign: 'center' }}>
                  {record.recording.archive_reason}
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>-</div>
              );
            },
          },
        ];
        break;
    }
    return (
      <React.Fragment>
        {COLUMS && COLUMS.length && (
          <CustomTableComponent
            columns={COLUMS}
            data={
              CCT_WORK_LIST_STATE &&
              CCT_WORK_LIST_STATE.recordings &&
              CCT_WORK_LIST_STATE.recordings.data &&
              CCT_WORK_LIST_STATE.recordings.data.items
            }
            clickedRow={this.clickedRow}
            // scrollHeight={{ y: 475 }}
            scrollHeight={{ y:  'calc(100vh - 35em)'}}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const CCT_WORK_LIST_STATE = state.kardiaRx.kardiaRxCCTWorklist;
  const CCT_DROPDOWN_VALUE =
    state.kardiaRx.kardiaRxCCTWorklist.selectedFilterDropdown;
  // const { form, search } = state;
  return {
    me,
    CCT_WORK_LIST_STATE,
    CCT_DROPDOWN_VALUE,
  };
};

const mapActionCreators = {
  routeChangeAction,
};
export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRxCCTWorkListResult));



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxCCTWorkListResult/KardiaRxCCTWorkListResult.jsx